"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

var _icon = _interopRequireDefault(require("./icon"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    leftIcon: {
      marginRight: theme.spacing(1)
    },
    marginTop: {
      marginTop: theme.spacing(3)
    }
  };
});

var handleClick = function handleClick(onClick) {
  if (onClick) {
    onClick();
  }
};

var Button = function Button(props) {
  var classes = useStyles();
  var type = props.type,
      disabled = props.disabled,
      label = props.label,
      icon = props.icon,
      fullWidth = props.fullWidth,
      variant = props.variant,
      marginTop = props.marginTop,
      _onClick = props.onClick;
  var className = marginTop !== false ? classes.marginTop : null;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: className,
    type: type,
    color: "primary",
    disabled: disabled,
    onClick: function onClick() {
      return handleClick(_onClick);
    },
    fullWidth: fullWidth,
    variant: variant
  }, icon ? /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: classes.leftIcon,
    icon: icon
  }) : null, label);
};

var _default = Button;
exports.default = _default;